var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12685 2.19291C5.89905 1.62343 5.34749 1.25 4.73413 1.25H2.67105C1.88623 1.25 1.25 1.88607 1.25 2.6709C1.25 9.34192 6.65808 14.75 13.3291 14.75C14.1139 14.75 14.75 14.1137 14.75 13.3289L14.7503 11.2655C14.7503 10.6521 14.377 10.1006 13.8075 9.87284L11.8302 9.0822C11.3186 8.87758 10.7362 8.96967 10.313 9.32239L9.80264 9.74801C9.20665 10.2447 8.32972 10.2052 7.78115 9.65659L6.34417 8.21829C5.79559 7.66972 5.75505 6.7935 6.25171 6.19751L6.67725 5.68722C7.02996 5.26397 7.12287 4.68137 6.91825 4.16982L6.12685 2.19291Z",
    stroke: "#989DA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline);
export default __webpack_public_path__ + "static/media/phone-outline.68bad0a8314c7878ce75d13fc8241361.svg";
export { ForwardRef as ReactComponent };